import { render, staticRenderFns } from "./gdyy.vue?vue&type=template&id=a49d70fc&scoped=true&"
import script from "./gdyy.vue?vue&type=script&lang=js&"
export * from "./gdyy.vue?vue&type=script&lang=js&"
import style0 from "./gdyy.vue?vue&type=style&index=0&id=a49d70fc&scoped=true&lang=css&"
import style1 from "./gdyy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49d70fc",
  null
  
)

export default component.exports